import { render, staticRenderFns } from "./Configuraciones.vue?vue&type=template&id=636fc6d9&scoped=true&"
import script from "./Configuraciones.vue?vue&type=script&lang=js&"
export * from "./Configuraciones.vue?vue&type=script&lang=js&"
import style0 from "./Configuraciones.vue?vue&type=style&index=0&id=636fc6d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636fc6d9",
  null
  
)

export default component.exports